import React, {
    AnchorHTMLAttributes,
    forwardRef,
    ForwardRefRenderFunction, useEffect,
    useImperativeHandle, useRef,
    useState,
} from 'react';
import classnames from 'classnames';



export interface SkipReference {

    time: (time: number) => void,
    duration: (duration: number) => void,
    start: (duration: number)=> void

}

type Props = {
    skip: () => void,
    volume: number,
    silent: (type: boolean)=>void
}

const MinForSkip = 10;
const MaxSkip = 10;

const SkipType: ForwardRefRenderFunction<SkipReference, Props> = (
    props,
    imperativeRef
) => {

    const [time, setTime] = useState(0);
    const [duration, setDuration] = useState(0);

    const setTimeRef  = useRef(setTime);
    setTimeRef.current = setTime;

    const setDurationRef  = useRef(setDuration);
    setDurationRef.current = setDuration;

    const interval = useRef<ReturnType<typeof setInterval>>()

    useEffect(()=>{
        return ()=>{
            if (interval.current)
                clearInterval(interval.current);
        }
    },[])

    useImperativeHandle(imperativeRef, ()=>({
        start: (duration: number)=>{
            if (interval.current)
                return;
            setDurationRef.current(duration);
            const begin = new Date().getTime();
            interval.current = setInterval(()=>{
                setTimeRef.current( (new Date().getTime() - begin)/1000);
            }, 300);
        },
        time: (time: number) =>{
            setTime(time);
        },
        duration: (duration:number)=>{
            setDuration(duration);
        }
    }));

    if (duration ===0)
        return <></>;

    let skip = false;

    let minutes = MaxSkip - time;
    if (minutes < 1)
        minutes = 0;

    const classNames = {
        'radiacz-skip': true,
        'radiacz-skip-enable': false
    };

    const aProps = {
        href: '#',

        onClick: (ev)=>{
            ev.preventDefault();
        }
    } as AnchorHTMLAttributes<HTMLAnchorElement>


    let text = `Přeskočit reklamu za ${Math.floor(minutes)}`;

    if (duration < MinForSkip) {
        text = `Rádio bude hrát za ${Math.floor(duration - time)}`;
    } else if (minutes < 1) {
        text = 'Přeskočit...'
        classNames['radiacz-skip-enable'] = true;
        aProps.onClick = (ev)=>{
            ev.preventDefault();
            if (minutes == 0 )
                props.skip();
        }
    }
    aProps.className = classnames(classNames);

    return <a {...aProps}>{text}</a>
}

export const Skip = forwardRef(SkipType);